import React, { useState } from "react";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

const ServiceCard = ({ title, image, price, features, additionalInfo }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { t, i18n } = useTranslation();

  const currentLanguage = i18n.language;

  return (
    <div className="bg-indigo-900/70 border border-indigo-500 rounded-lg overflow-hidden shadow-lg">
      <img src={image} alt={title} className="w-full h-48 object-cover" />
      <div
        className="p-4"
        style={{
          display: "flex",
          flexDirection: " column",
          height: currentLanguage === "alb" ? "300px" : "250px",
        }}
      >
        <div style={{ height: "70%" }}>
          <h3 className="text-xl font-bold text-white mb-2">{title}</h3>
          <p className="text-indigo-200 font-semibold mb-2">
            {/* From £{price} */}
          </p>
          <ul className="mb-4">
            {features.map((feature, index) => (
              <li key={index} className="flex items-center text-white mb-1">
                <svg
                  className="w-4 h-4 mr-2 text-green-400"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M5 13l4 4L19 7"></path>
                </svg>
                {feature}
              </li>
            ))}
          </ul>
        </div>

        <div style={{ height: "30%", display: "flex", alignItems: "flex-end" }}>
          <div style={{ width: "100%" }}>
            <button
              onClick={() => setIsModalOpen(true)}
              className="w-full bg-indigo-500 hover:bg-indigo-600 text-white font-bold py-2 px-4 rounded transition duration-300"
            >
              {t("learnMore")}
            </button>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4 z-50">
          <div className="bg-indigo-900 rounded-lg p-6 max-w-md w-full">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-white">{title}</h3>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-indigo-200 hover:text-white"
              >
                <X size={24} />
              </button>
            </div>
            <p className="text-white mb-4">{additionalInfo}</p>
            <button
              onClick={() => setIsModalOpen(false)}
              className="w-full bg-indigo-500 hover:bg-indigo-600 text-white font-bold py-2 px-4 rounded transition duration-300"
            >
              {t("close")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const PopularServicesGrid = () => {
  const { t } = useTranslation();

  const services = [
    {
      title: "Australia Tourist eVisitor Visa",
      image: "australi.jpeg",
      // price: "30.00",
      features: [
        t("australiaFeatures1"),
        t("australiaFeatures2"),
        t("australiaFeatures3"),
      ],
      additionalInfo: t("australiaInfoText"),
    },
    {
      title: "USA tourist / business visa",
      image: "usImg.jpeg",
      // price: "25.00",
      features: [t("usaFeatures1"), t("usaFeatures2"), t("usaFeatures3")],
      additionalInfo: t("usaInfoText"),
    },
    {
      title: "British tourist / business / student visa",
      image: "uk.jpeg",
      // price: "20.00",
      features: [t("ukFeatures1"), t("ukFeatures2"), t("ukFeatures3")],
      additionalInfo: t("ukInfoText"),
    },
  ];

  return (
    <div
      className="w-full max-w-4xl mx-auto mt-12 px-4"
      style={{ maxWidth: "49rem" }}
    >
      <h2 className="text-3xl font-bold text-white mb-6">
        {t("popularServices")}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((service, index) => (
          <ServiceCard key={index} {...service} />
        ))}
      </div>
    </div>
  );
};

export default PopularServicesGrid;
